import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getGuardianStudentAssessmentsByGroupAndMatrixDate } from 'actions/sections';
import './Styles.scss';
var Line = /*#__PURE__*/function (_Component) {
  function Line(props) {
    var _this;
    _classCallCheck(this, Line);
    _this = _callSuper(this, Line, [props]);
    _defineProperty(_this, "componentDidMount", function () {
      var matrixId = _this.props.detail.matrixID;
      _this.props.getGuardianStudentAssessmentsByGroupAndMatrixDate(_this.props.activeStudent, _this.props.group.id, matrixId, _this.props.start, _this.props.end).then(function (data) {
        var stats = [];
        var gradeIndexColors = ['#AAC4CE',
        // 0
        '#59B0F0',
        // 1
        '#577BF2',
        // 2
        '#6416E2' // 3
        ];
        data.statistics.map(function (stat) {
          stats.push({
            amount: stat.count,
            label: stat.count,
            color: gradeIndexColors[stat.index]
          });
        });
        _this.setState({
          data: stats
        });
      });
    });
    _defineProperty(_this, "renderLine", function () {
      var _this$props = _this.props,
        showAmount = _this$props.showAmount,
        showLabel = _this$props.showLabel;
      if (_this.state.data != null) {
        var steps = [];
        var total = _this.state.data.map(function (item) {
          return parseInt(item.amount, 10);
        }).reduce(function (prev, next) {
          return prev + next;
        });
        _this.state.data.map(function (step) {
          var stepWidth = 0;
          if (total > 0) {
            stepWidth = parseInt(step.amount, 10) / total * 100 + '%';
          } else {
            stepWidth = 100 / data.length + '%';
          }
          steps.push({
            width: stepWidth,
            label: step.label ? step.label : '',
            color: step.color ? step.color : '#9E82EB',
            amount: step.amount
          });
        });
        return /*#__PURE__*/React.createElement("div", {
          className: "bar-container"
        }, steps.map(function (step, i) {
          var style = step.width == '0%' ? {
            padding: '0.2em 0.3em !important',
            backgroundColor: step.color
          } : {
            width: step.width,
            backgroundColor: step.color
          };
          return /*#__PURE__*/React.createElement("span", {
            key: i,
            className: "step",
            style: style
          }, showLabel ? step.label : null, showAmount ? " ".concat(step.amount) : null, showPercentage ? " ".concat(step.width, "%") : null);
        }));
      }
    });
    _this.state = {
      data: null
    };
    return _this;
  }
  _inherits(Line, _Component);
  return _createClass(Line, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;
      if (nextProps.start != this.props.start || nextProps.end != this.props.end) {
        var matrixId = this.props.detail.matrixID;
        this.props.getGuardianStudentAssessmentsByGroupAndMatrixDate(this.props.activeStudent, this.props.group.id, matrixId, nextProps.start, nextProps.end).then(function (data) {
          var stats = [];
          var gradeIndexColors = ['#AAC4CE',
          // 0
          '#59B0F0',
          // 1
          '#577BF2',
          // 2
          '#6416E2' // 3
          ];
          data.statistics.map(function (stat) {
            stats.push({
              amount: stat.count,
              label: stat.count,
              color: gradeIndexColors[stat.index]
            });
          });
          _this2.setState({
            data: stats
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "graph line"
      }, this.renderLine());
    }
  }]);
}(Component);
_defineProperty(Line, "defaultProps", {
  showAmount: false,
  showLabel: false
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    group: state.groups.activeGroup,
    activeStudent: state.guardians.activeStudent
  };
};
export default connect(mapStateToProps, {
  getGuardianStudentAssessmentsByGroupAndMatrixDate: getGuardianStudentAssessmentsByGroupAndMatrixDate
})(Line);